/* eslint-disable no-script-url */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-08-15 17:57:16
 * Copyright © Leedarson. All rights reserved.
 */

import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  useMemo,
  forwardRef,
} from 'react';
import clsx from 'clsx';
// import native from '@native';
// import { StyledInput, StyledBoxTouchEnd, StyledBox } from './StyledInput';
import Icon from '../Icon';
// import Box from '../box';
import { InputProps } from './types';
import './index.less';
import { isMobile, noop } from '@shared';
const { EMPTY_FUNCTION } = noop;

// eslint-disable-next-line react/display-name
const InputBase = forwardRef(
  (
    {
      type = 'text',
      readOnly = false,
      disabled = false,
      placeholder = '',
      defaultValue,
      onChange = EMPTY_FUNCTION,
      onBlur = EMPTY_FUNCTION,
      onFocus = EMPTY_FUNCTION,
      onKeyDown = EMPTY_FUNCTION,
      eye = false,
      edit = false,
      clear = false,
      // fontWeight,
      value: inputValue,
      forwardedRef,
      // align,
      needClearContent = false,
      // autoFill,
      autoFocusForFirstTime = false,
      eyeDefaultStatus,
      className,
      ...rests
    }: InputProps,
    ref: any,
  ) => {
    const [value, setValue] = useState(defaultValue || inputValue);
    const [eyeStatus, setEyeStatus] = useState(eyeDefaultStatus);
    const [editVisible, setEditVisible] = useState(true);
    const [clearVisible, setClearVisible] = useState(false);
    const visualFocusRef = useRef<boolean>(false);
    const inputRef = useRef<HTMLInputElement>();
    const timer = useRef<any>();

    useEffect(() => {
      setEyeStatus(eyeDefaultStatus);
    }, [eyeDefaultStatus]);

    useEffect(() => {
      setValue(inputValue);
    }, [inputValue]);

    const handleInputClearClick = useCallback(
      (e: any) => {
        setValue('');
        onChange(e);
        visualFocusRef.current = true;
        //  让 input 内的值更新后在去获取焦点  ，位的是让获取焦点后渠去到的input的值是空的
        setTimeout(() => {
          visualFocusRef.current = false;
          if (inputRef.current) {
            inputRef.current.focus();
          }
          setClearVisible(false);
        }, 0);
      },
      [onChange],
    );

    const handleInputFocus = useCallback(
      (e: any) => {
        clearTimeout(timer.current);
        const latestValue = e.target.value;
        if (latestValue.length !== 0 && !disabled && !readOnly) {
          setClearVisible(true);
        }
        if (!disabled && !readOnly) {
          setEditVisible(false);
        }
        // clearTimeout(window.controlKeyboard);
        onFocus(e);
      },
      [disabled, onFocus, readOnly],
    );

    const handleInputBlur = useCallback(
      (e: any) => {
        // window.controlKeyboard = setTimeout(() => {
        //   native.system.closeKeyboard();
        // }, 300);
        e.persist();
        setClearVisible(false);
        setEditVisible(true);
        if (visualFocusRef.current) {
          return;
        }
        onBlur(e);
      },
      [onBlur],
    );

    const handleInputChange = useCallback(
      (e: any) => {
        if (!needClearContent) {
          setValue(e.target.value);
        }
        if (e.target.value.length === 0) {
          setClearVisible(false);
        } else {
          setClearVisible(true);
        }
        onChange(e);
      },
      [needClearContent, onChange],
    );

    const handleInputEyeClick = useCallback(() => {
      setEyeStatus(!eyeStatus);
    }, [eyeStatus]);

    const handleInputEditClick = () => {
      inputRef.current && inputRef.current.focus();
    };

    const handleKeyDown = useCallback(
      (e: any) => {
        onKeyDown(e);
      },
      [onKeyDown],
    );

    // 第一次自动聚焦
    const autoFocusRef = useRef(false);
    useEffect(() => {
      if (inputRef.current && autoFocusForFirstTime && !autoFocusRef.current) {
        autoFocusRef.current = true;
        setTimeout(() => {
          inputRef.current && inputRef.current.focus();
        }, 500);
      }
    }, [autoFocusForFirstTime]);

    const content = useMemo(() => {
      return (
        <div className={clsx(className, 'input-wrap')}>
          <input
            ref={(input) => {
              (inputRef as any).current = input;
              if (forwardedRef) {
                forwardedRef.current = input;
              }
            }}
            value={value}
            type={eyeStatus ? 'text' : type}
            // textAlign={align}
            // fontWeight={fontWeight}
            // readOnly={readOnly}
            // disabled={disabled}
            placeholder={placeholder}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onFocus={handleInputFocus}
            onKeyDown={handleKeyDown}
            // autoFill={autoFill}
            {...rests}
            className={clsx('input-base', { disabled, readOnly })}
          />
          {clearVisible && clear && !readOnly ? (
            <div
              style={{
                width: 22,
                height: 22,
                position: 'relative',
                margin: eye ? '0 8px 0 0' : 0,
                cursor: 'pointer',
              }}
            >
              <div
                className="iconTouchEnd"
                onMouseDown={isMobile ? undefined : handleInputClearClick}
                onTouchEnd={isMobile ? handleInputClearClick : undefined}
              />
              <Icon className="neuter600" fontSize="22px" type="clear" />
            </div>
          ) : (
            ''
          )}
          {eye ? (
            <div style={{ margin: '0 0 0 8px' }}>
              <Icon
                onClick={handleInputEyeClick}
                type={eyeStatus ? 'eye-open' : 'eye-close'}
                className="neuter600"
                fontSize={20}
              />
            </div>
          ) : (
            ''
          )}
          {editVisible && edit && !disabled ? (
            <div style={{ margin: '0 0 0 8px' }}>
              <Icon
                onClick={handleInputEditClick}
                type="edit"
                className="neuter600"
                fontSize={20}
              />
            </div>
          ) : (
            <div
              style={{
                width: 5,
                height: 5,
              }}
            />
          )}
        </div>
      );
    }, [
      clear,
      clearVisible,
      disabled,
      edit,
      editVisible,
      eye,
      eyeStatus,
      forwardedRef,
      handleInputBlur,
      handleInputChange,
      handleInputClearClick,
      handleInputEyeClick,
      handleInputFocus,
      handleKeyDown,
      placeholder,
      readOnly,
      rests,
      type,
      value,
      className,
    ]);

    return type === 'search' ? (
      <form action="javascript:true">{content}</form>
    ) : (
      content
    );
  },
);

export default InputBase;
